// Generated by CoffeeScript 2.3.2

import PerCategoryCardChooser from './PerCategoryCardChooser'
import PlayerChooser from './PlayerChooser'

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography'
;
var CommlinkDialog, ShowedChooser,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

ShowedChooser = function(props) {
  var value;
  value = props.value ? "yes" : "no";
  return <FormControl component="fieldset">
    <RadioGroup row name="showed" value={value} onChange={props.onChange}>
      <FormControlLabel value="yes" control={<Radio />} label="Yes" /> 
      <FormControlLabel value="no" control={<Radio />} label="No" /> 
    </RadioGroup>
  </FormControl>;
};

CommlinkDialog = class CommlinkDialog extends Component {
  constructor(props) {
    super(props);
    this.handleChangeCallerId = this.handleChangeCallerId.bind(this);
    this.handleChangeSubjectId = this.handleChangeSubjectId.bind(this);
    this.handleChangeCards = this.handleChangeCards.bind(this);
    this.handleChangeShowed = this.handleChangeShowed.bind(this);
    this.handleDone = this.handleDone.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.state = {
      callerId: null,
      receiverId: null,
      cardIds: {},
      showed: false
    };
    return;
  }

  close() {
    this.setState({
      callerId: null,
      receiverId: null,
      cardIds: {},
      showed: false
    });
    this.props.onClose();
  }

  stateIsOk() {
    var cardCount, key;
    cardCount = ((function() {
      var results;
      results = [];
      for (key in this.state.cardIds) {
        results.push(key);
      }
      return results;
    }).call(this)).length;
    return (this.state.callerId != null) && (this.state.receiverId != null) && cardCount === 3;
  }

  handleChangeCallerId(playerId) {
    boundMethodCheck(this, CommlinkDialog);
    this.setState({
      callerId: playerId
    });
  }

  handleChangeSubjectId(playerId) {
    boundMethodCheck(this, CommlinkDialog);
    this.setState({
      receiverId: playerId
    });
  }

  handleChangeCards(typeId, cardId) {
    boundMethodCheck(this, CommlinkDialog);
    this.setState(function(state, props) {
      var newCardIds;
      newCardIds = Object.assign({}, state.cardIds);
      newCardIds[typeId] = cardId;
      return {
        cardIds: newCardIds
      };
    });
  }

  handleChangeShowed(event) {
    boundMethodCheck(this, CommlinkDialog);
    this.setState({
      showed: event.target.value === "yes"
    });
  }

  handleDone() {
    var cardId, cardIds, typeId;
    boundMethodCheck(this, CommlinkDialog);
    if (this.stateIsOk()) {
      cardIds = (function() {
        var ref, results;
        ref = this.state.cardIds;
        results = [];
        for (typeId in ref) {
          cardId = ref[typeId];
          results.push(cardId);
        }
        return results;
      }).call(this);
      this.props.app.recordCommlink(this.state.callerId, this.state.receiverId, cardIds, this.state.showed);
      this.close();
    } else {
      this.props.app.showConfirmDialog("Error", "You must select an caller, a receiver, and one card of each type.");
    }
  }

  handleCancel() {
    boundMethodCheck(this, CommlinkDialog);
    this.close();
  }

  render() {
    var configuration, open, players;
    ({open, players, configuration} = this.props);
    return <Dialog open={open} fullscreen="true" disableBackdropClick={true} onClose={this.handleClose}>
      <DialogTitle id="form-dialog-title"> Record A Commlink </DialogTitle>
      <DialogContent>
        <Typography variant="h4"> Who is the caller? </Typography>
        <PlayerChooser value={this.state.callerId} players={players} excluded={this.state.receiverId != null ? [this.state.receiverId] : []} onChange={this.handleChangeCallerId} />
        <Divider />
        <Typography variant="h4"> Who is the receiver? </Typography>
        <PlayerChooser value={this.state.receiverId} players={players} excluded={this.state.callerId != null ? [this.state.callerId] : []} onChange={this.handleChangeSubjectId} />
        <Divider />
        <Typography variant="h4"> Which cards? </Typography>
        <PerCategoryCardChooser value={this.state.cardIds} cards={configuration.cards} types={configuration.types} onChange={this.handleChangeCards} />
        <Divider />
          <Typography variant="h4"> Was a card shown? </Typography>
          <ShowedChooser value={this.state.showed} onChange={this.handleChangeShowed} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={this.handleCancel}>Cancel</Button>
        <Button disabled={!this.stateIsOk()} variant="contained" color="primary" onClick={this.handleDone}>Done</Button>
      </DialogActions>
    </Dialog>;
  }

};

export default CommlinkDialog;
